import React from 'react'
import Layout from '../../Layout.jsx';
import '../../CustomAssets/Css/Pages/SubPages/TermsConditionsPrivacyPolicy.css';

export default function TermsConditions() {
  return (
    <>
      <Layout>

        <section className="banner org_clr">
          <div className="container ">
            <div className="row gy-4 gy-sm-0 align-items-center justifyCenter">
              <div className="col-12  col-sm-12">
                <div className="banner__content">
                  <h1 className="banner__title display-4 wow fadeInLeft textCenter" data-wow-duration="0.8s">Terms And Conditions</h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="tp-page-area sec-mar">
          <div className="container-fluid custom-container">
            <div className="row">
              <div className="col-xl-12">
                <div className="tp-page-content">
                  <div className="tp-page-post">
                    <div data-elementor-type="wp-page" data-elementor-id="47" className="elementor elementor-47">

                      <div className="elementor-element elementor-element-3183344" data-id="3183344"
                        data-element_type="container">
                        <div className="elementor-element elementor-element-ebda982 elementor-widget elementor-widget-tp-choose"
                          data-id="ebda982" data-element_type="widget" data-widget_type="tp-choose.default">
                          <div className="elementor-widget-container">


                            <section className="choose-us ">

                              <div className="container">
                                <div className="row gy-5 gy-lg-0 justify-content-between align-items-center section">
                                  <div className="col-12 col-lg-12 col-xxl-12">
                                    <div className="section__content ms-lg-4 ms-xl-0">

                                      <div className='tmndcm'>
                                        <h2 className="title section__content-title wow fadeInUp" data-wow-duration="0.8s">Refund & Cancellation Policy – LOANSMONEY.IN</h2>

                                        <div className="section__content-inner wow fadeInUp" data-wow-duration="0.8s">
                                          <p>At LOANSMONEY, our goal is to ensure complete satisfaction through dependable services. We continuously strive to provide top-tier financial solutions via our digital platform. However, if you ever feel that our service did not meet your expectations, we encourage you to reach out to your dedicated Relationship Manager or contact our support team at support@loansmoney.in. We will evaluate the issue and offer a fair resolution.</p>
                                        </div>
                                      </div>


                                      <div className='tmndcm'>
                                        <h2 className="title section__content-title wow fadeInUp" data-wow-duration="0.8s">CRM Subscription Refund Guidelines</h2>

                                        <div className="section__content-inner wow fadeInUp" data-wow-duration="0.8s">
                                          <p>Once the CRM subscription payment is received, access credentials will be issued via email. If the login ID fails to activate or the partner dashboard is non-functional within the expected timeframe, we assure a full refund within 6 working days.</p>
                                        </div>
                                      </div>

                                      <div className='tmndcm'>
                                        <h2 className="title section__content-title wow fadeInUp" data-wow-duration="0.8s">Post-Agreement Policy</h2>

                                        <div className="section__content-inner wow fadeInUp" data-wow-duration="0.8s">
                                          <p>By accessing or using any services provided by LOANSMONEY PRIVATE LIMITED, you agree to abide by all terms, conditions, and policies set forth herein. The use of this platform is intended solely for individuals seeking financial products and services through our partnered Banks and NBFCs. All services are subject to eligibility, verification, and approval by the respective financial institutions.
                                            <br />
                                            Users must provide accurate, current, and complete information. LOANSMONEY reserves the right to suspend or terminate access if any information provided is found to be false or misleading. The company disclaims any liability arising from third-party decisions, as we do not interfere with the independent policies of Banks or NBFCs regarding loan approvals or rejections.
                                            <br />
                                            All digital content, logos, and branding displayed on this platform are the intellectual property of LOANSMONEY and cannot be reused or reproduced without written consent.
                                            <br />
                                            Any disputes arising from the use of this website shall be governed by Indian laws and fall under the jurisdiction of competent courts located in India.
                                            <br />
                                            By continuing to use this site, you confirm that you have read, understood, and agreed to the terms outlined in this document, including the Privacy Policy, Disclaimer, and any additional guidelines issued from time to time.</p>
                                        </div>
                                      </div>

                                      <div className='tmndcm'>
                                        <h2 className="title section__content-title wow fadeInUp" data-wow-duration="0.8s">Refund Process & Service Fee</h2>

                                        <div className="section__content-inner wow fadeInUp" data-wow-duration="0.8s">
                                          <p>Our first approach is always to work with you and resolve any service-related concern. However, if a refund is still requested, the following terms apply: </p>

                                          <div>
                                            <ul className='tmcndl custom-check'>
                                              <li><strong className='ftr_txt_clr'>25% cancellation fee</strong> will be deducted.</li>
                                              <li>Additional deductions include any government charges or fees already incurred.</li>
                                              <li>In service changes, cancellation fees may be waived.</li>
                                            </ul>
                                          </div>


                                          <p>LOANSMONEY will evaluate each case on its merit and refund a maximum of 75% of the paid fee if applicable. Our team commits to transparency and will provide a breakdown of any deductions.
                                          </p>

                                        </div>
                                      </div>

                                      <div className='tmndcm'>
                                        <h2 className="title section__content-title wow fadeInUp" data-wow-duration="0.8s">Service Disclaimer</h2>

                                        <div className="section__content-inner wow fadeInUp" data-wow-duration="0.8s">
                                          <p>We guarantee our services—not loan approvals. All loans are subject to documentation, eligibility, and bank/NBFC policy. LOANSMONEY is an official partner of multiple financial institutions but does not guarantee loan approvals. If someone makes a loan-related promise or requests money for loan approval, report the matter to support@loansmoney.in immediately.
                                            <br />
                                            Important: Never share sensitive banking details such as debit card numbers, CVV, or OTPs. LOANSMONEY will never ask for these.</p>
                                        </div>
                                      </div>


                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>


                          </div>
                        </div>
                      </div>




                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </Layout>

    </>
  )
}
